const personNameField = {
  component: 'TextFieldHiddenSchema',
  maxLength: 40,
};

export default personNameField;
